import { Component, OnInit } from '@angular/core';

import { Router, ActivatedRoute, NavigationStart, Event as NavigationEvent } from '@angular/router';
import {NetworkHelperService} from '../../../_services/network-helper.service';
import {FORMS, API, CODFUNC, PAGE, GENERALES} from '../../../_config/strings';
import Swal from 'sweetalert2';
import {Usuario} from '../../../_model/Usuario';
import {Cliente} from '../../../_model/Cliente';
import swal from 'sweetalert2';
import * as moment from 'moment';
import {Subject} from 'rxjs/Subject';
import {Chart} from 'chart.js';
import { ChatService } from '../../../_services/chat.service';
import { DataTablesModule } from 'angular-datatables';

@Component({
  selector: 'app-material-almacen',
  templateUrl: './material-almacen.component.html',
  styleUrls: ['./material-almacen.component.scss']
})

export class MaterialAlmacenComponent implements OnInit {

  // Propiedades de dataTable
  /*
  dtOptions: DataTables.Settings = {
    pageLength: 8,
    lengthChange: false,
    info: false
  };
  */
  // Obserbables
  // dtTrigger: Subject<any> = new Subject();

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  LineChart;

  FORMS: any;
  API: any;
  GENERALES: any;
  PAGE: any;

  sucursal;
  boolLoader = false;
  boolTrigger = true;

  // Aray´s
  arrayEstibas = [];
  arrayFisico = [];
  arrayInservible = [];
  arrayMantenimiento = [];
  arrayObra = [];
  arrayReservado = [];
  arrayTransito = [];
  arrayVenta = [];
  arrayGrafica = [];
  arrayObjeto;
  arrayMaterial = [];
  arrayResguardo = [];

  // Variables
  cantidadEstibas;
  cantidadFisico;
  cantidadInservible;
  cantidadMantenimiento;
  cantidadObra;
  cantidadReservado;
  cantidadTransito;
  cantidadVenta;
  cantidadEspera;
  cantidadResguardo;

  public usuario: Usuario = new Usuario();
  public cliente: Cliente;

  constructor(
    private activatedRoute: ActivatedRoute,
    private network: NetworkHelperService,
    private rutas: Router,
    private chat: ChatService,
  ) {
    this.FORMS = FORMS;
    this.API = API;
    this.GENERALES = GENERALES;
    this.PAGE = PAGE;
    this.usuario = JSON.parse( localStorage.getItem('usuario') );
  }

  ngOnInit() {
    this.sucursal = this.usuario.sucId;
    this.grafica();
    this.productosGrafica();
    // Chart
    this.listarProductosAlmacenes();
  }

  productosGrafica () {
    const JSONROL = {
      sucursalId: this.sucursal
    };
    this.network.callSecureService(
      this.API.user.almacenes + '/' + this.API.user.productos + '/' + this.API.user.stock,
      'POST',
      JSONROL
    ).subscribe((response: any) => {
      console.log(response);
      if ( response.Estatus === 200 ) {
        this.arrayObjeto = response.Mensaje;
        this.cantidadEspera = this.arrayObjeto.ESPERA.length;
        this.cantidadEstibas = this.arrayObjeto.ESTIBAS.length;
        this.cantidadFisico = this.arrayObjeto.FISICO.length;
        this.cantidadInservible = this.arrayObjeto.INSERVIBLE.length;
        this.cantidadMantenimiento = this.arrayObjeto.MANTENIMIENTO.length;
        this.cantidadObra = this.arrayObjeto.OBRA.length;
        this.cantidadReservado = this.arrayObjeto.RESERVADO.length;
        this.cantidadTransito = this.arrayObjeto.TRANSITO.length;
        this.cantidadVenta = this.arrayObjeto.VENTA.length;
        this.cantidadResguardo = this.arrayObjeto.RESGUARDO.length;
        this.arrayGrafica = [
          this.arrayObjeto.FISICO.length,
          this.arrayObjeto.RESERVADO.length,
          this.arrayObjeto.ESPERA.length,
          this.arrayObjeto.OBRA.length,
          this.arrayObjeto.RESGUARDO.length,
          this.arrayObjeto.INSERVIBLE.length,
          this.arrayObjeto.MANTENIMIENTO.length,
          this.arrayObjeto.ESTIBAS.length,
          this.arrayObjeto.TRANSITO.length,
          this.arrayObjeto.VENTA.length
        ];
        // this.grafica();
        this.LineChart.data.datasets[0].data = this.arrayGrafica;
        this.LineChart.data.labels = [
          // 'Estibas: ' + this.cantidadEstibas,
          'Físico: ' + this.arrayObjeto.FISICO.length,
          'Reservado: ' + this.arrayObjeto.RESERVADO.length,
          'En espera: ' + this.arrayObjeto.ESPERA.length,
          'Obra: ' + this.arrayObjeto.OBRA.length,
          'Resguardo: ' + this.arrayObjeto.RESGUARDO.length,
          'Inservible: ' + this.arrayObjeto.INSERVIBLE.length,
          'Mantenimiento: ' + this.arrayObjeto.MANTENIMIENTO.length,
          'Estibas: ' + this.arrayObjeto.ESTIBAS.length,
          'Tránsito: ' + this.arrayObjeto.TRANSITO.length,
          'Venta: ' + this.arrayObjeto.VENTA.length
        ];
        this.LineChart.update();
      }
    }, err => {
      console.log(err);
      Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
    });
  }

  // En el siguiente método se limpia el arrayGrafica y se vuelve a llamar la clase para asignar los valores al mismo array.
  sucursalMetodo() {
    this.productosGrafica();
    const table = $('#tablaMaterial').DataTable();
    table.destroy();
    this.listarProductosAlmacenes();
    this.boolLoader = true;
    document.getElementById('tablaMaterial').style.display = 'none';
  }

  // GRAFICA
  grafica () {
    this.LineChart = new Chart('lineChart', {
      type: 'doughnut',
      // type: 'doughnut',
      data: {
        labels: [
          'Físico: ' + this.cantidadFisico,
          'Reservado: ' + this.cantidadReservado,
          'En espera: ' + this.cantidadEspera,
          'Obra: ' + this.cantidadObra,
          'Resguardo: ' + this.cantidadResguardo,
          'Inservible: ' + this.cantidadInservible,
          'Mantenimiento: ' + this.cantidadMantenimiento,
          'Estibas: ' + this.cantidadEstibas,
          'Tránsito: ' + this.cantidadTransito,
          'Venta: ' + this.cantidadVenta
        ],
        datasets: [{
          label: 'Number of items',
          data: this.arrayGrafica,
          fill: false,
          lineTension: 0.2,
          // borderColor: 'red',
          backgroundColor: [
            'rgba(0, 204, 0, 0.2)',
            'rgba(255, 140, 26, 0.2)',
            'rgba(44, 162, 235, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(255, 0, 0, 0.2)',
            'rgba(235, 70, 170, 0.2)',
            'rgba(255, 246, 86, 0.2)',
            'rgba(179, 36, 0, 0.2)',
            'rgba(153, 102, 255, 0.2)',
            'rgba(0, 0, 255, 0.2)',
          ],
          borderColor: [
            'rgba(0, 204, 0, 1)',
            'rgba(255, 140, 26, 1)',
            'rgba(44, 162, 235, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(255, 0, 0, 1)',
            'rgba(235, 70, 170, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(179, 36, 0, 1)',
            'rgba(153, 102, 255, 1)',
            'rgba(0, 0, 255, 1)',
          ],
          borderWidth: 1
        }]
      },
      options: {
        title: {
          text: 'Cantidad de productos por almacén',
          display: true
        },
        /*
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
        */
      }
    });
  }
  // GRAFICA

  listarProductosAlmacenes () {
    const JSONALMACEN = {
      sucursalId: this.sucursal
    };
    this.network.callSecureService(
      this.API.user.almacenes + '/' + this.API.user.productos + '/' + this.API.user.almacenes,
      'POST',
      JSONALMACEN
    ).subscribe((response: any) => {
      console.log( response );
      if ( response.Estatus === 201 ) {
        this.arrayMaterial = response.Mensaje;
      }
      if (this.boolTrigger) {
        this.dtTrigger.next();
      }
      this.boolLoader = false;
      document.getElementById('tablaMaterial').style.display = 'block';
    }, err => {
      console.log(err);
      Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
    });
  }

  actualizarInventarios() {
    this.boolTrigger = false;
    this.grafica();
    this.productosGrafica();
    // Chart
    this.listarProductosAlmacenes();
    this.boolLoader = true;
    document.getElementById('tablaMaterial').style.display = 'none';
    // this.rutas.navigate(['dashboard/menuAlmacen/materialAlmacen' ]);
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/material-almacen/material-almacen.component.ts